module.exports = __webpack_public_path__ + "assets/GoldUpsilon.71fafdd51ef77d06cb4e154891de6d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldUpsilon.png
// module id = 777
// module chunks = 0